import { css } from 'linaria';

export const fullWidthMobileutton = css`
  @media (--only-mobile) {
    width: 100%;
  }
`;
